import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, TimePicker, DatePicker } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';

import { addCategory, getCategory } from '../../feature/category/CategorySlice';
import { categoryTypes } from '../../constant/Constatnt';



function AddCategory({ types }) {
    const { actionLoader } = useSelector((state) => state.categories);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    const onFinish = async (values) => {

        const resultAction = await dispatch(addCategory(values));
        if (addCategory.fulfilled.match(resultAction)) {
            await dispatch(getCategory({ types: types }));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("Add category");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item
                name="categoryType"
                label="Select  Type"
                rules={[{ required: true, message: 'Please select category type ' }]}
            >
                <Select placeholder="Select  Category Type">
                    {categoryTypes.map((opt) => (
                        <Select.Option value={opt} key={opt}>{opt}</Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                name="categoryName"
                label="Category Name"
                rules={[{ required: true, message: 'Please enter  category name ' }]}
            >
                <Input placeholder='Enter Category Name' />
            </Form.Item>

            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const AddConsultationProps = {
        open,
        setOpen,
        title: 'Add New Category',
        action: 'Add',
        content: AddForm,
    };

    return (
        <section>
            <AddDrawer {...AddConsultationProps} />
        </section>
    );
}



export default AddCategory